import { Box, HStack, Icon, Text } from "@chakra-ui/react";
import { FaCircleNotch } from "react-icons/fa";
import { useTranslation } from "react-i18next";

export const SigningPill = () => {
  const { t } = useTranslation();
  return (
    <HStack
      spacing="2"
      bg="smWarningSoft"
      borderWidth="1px"
      borderColor="smWarningSoftBorder"
      color="smWarning"
      px="3"
      py="1"
      borderRadius="full"
      display="inline-flex"
      width="fit-content"
    >
      <Icon as={FaCircleNotch} boxSize="3" />
      <Text fontSize="sm" fontWeight="medium">
        {t("Signing in progress")}
      </Text>
      <Box />
    </HStack>
  );
};
